import React from "react";
import { StepProps } from "../../types";
import { useWebTranslation } from "translations";
import { SignUpProductEnum } from "components/Signup/flow/SignupFlow/types";
import ChatMessage, { ChatContainer } from "ui-kit/ChatMessage/ChatMessage";
import { Typography } from "ui-kit/Typography";
import Gutter from "ui-kit/Gutter";
import { useCurrentAnimal } from "components/Signup/store/selectors/animals";
import { FlexRow } from "ui-kit/Layout/Flex";
import { updateInsuranceById } from "components/Signup/store/slices/animals";
import { useSignupDispatch } from "components/Signup/store/hooks";
import { useCurrentInsuranceByAnimalId } from "components/Signup/store/selectors/insurance";
import {
  getGermanDefaultHealthIsuranceSettings,
  getGermanDefaultLiabilityInsuranceSettings,
} from "components/Signup/store/state/utils";

export const Product = ({ next, transitioning }: StepProps) => {
  const { t } = useWebTranslation();
  const dispatch = useSignupDispatch();

  const { id } = useCurrentAnimal();
  const { product, id: insuranceID } = useCurrentInsuranceByAnimalId(id);

  const products = [
    {
      label: t("global.health_product"),
      value: SignUpProductEnum.health,
    },
    {
      label: t("global.liability_product"),
      value: SignUpProductEnum.liability,
    },
  ];

  return (
    <>
      <ChatContainer leaving={transitioning}>
        <ChatMessage index={1}>
          <Typography>{t("signup.product.text")}</Typography>
        </ChatMessage>
        <Gutter size={2} />
        {products.map((item, index) => (
          <ChatMessage
            key={item.value}
            blink
            fromMe
            component="button"
            data-testid={item.label}
            index={index + 2}
            onPress={async () => {
              dispatch(
                updateInsuranceById(
                  {
                    id: insuranceID,
                    update: {
                      ...(item.value === SignUpProductEnum.liability
                        ? getGermanDefaultLiabilityInsuranceSettings()
                        : getGermanDefaultHealthIsuranceSettings()),
                    },
                  },
                  { refetch: false }
                )
              );

              next();
            }}
            active={product === item.value}
          >
            <FlexRow alignItems="center">
              <Typography>{item.label}</Typography>
            </FlexRow>
          </ChatMessage>
        ))}
      </ChatContainer>
    </>
  );
};

export default Product;
